import script from "./ai-property-listing-wizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-property-listing-wizard.vue?vue&type=script&setup=true&lang=ts"

import "./ai-property-listing-wizard.vue?vue&type=style&index=0&id=130b7cd1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130b7cd1"]])

export default __exports__